export const WIDGET_ID = "result-search-share";
